import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ListPrivacyRequestsResponse, PrivacyRequest, PrivacyRequestInput } from 'shared';
import { api } from '@/lib/api';
import { useAuthStore } from '@/stores/auth';

const MINE = ['privacy-requests', 'mine'] as const;

/** GET /api/privacy-requests/mine — the signed-in Digger's or Encarregado's own requests. */
export function useMyPrivacyRequests() {
  const { isAuthenticated, kind } = useAuthStore();
  return useQuery({
    queryKey: MINE,
    queryFn: () => api.get<ListPrivacyRequestsResponse>('/api/privacy-requests/mine'),
    enabled: isAuthenticated && (kind === 'participant' || kind === 'guardian'),
  });
}

/** POST /api/privacy-requests — asking again for something open changes nothing. */
export function useCreatePrivacyRequest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: PrivacyRequestInput) => api.post<PrivacyRequest>('/api/privacy-requests', input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: MINE }),
  });
}
